/**
 * Catalog slugs that get a /:service-in-:city page (and a tile on every city
 * hub). Slugs, not names: clinics store services[].slug from the live
 * service_catalog, and the centres API filters on it exactly. Names for
 * display come from useCatalog() so they always match what clinics list.
 * Consumed by CityHub, SectorService, scripts/prerender.mjs and the sitemap.
 */
export const TOP_SERVICE_SLUGS = [
  'back-pain-therapy',
  'neck-pain-therapy',
  'knee-pain-therapy',
  'sciatica-pain-therapy',
  'frozen-shoulder-therapy',
  'sports-injury-rehabilitation',
  'post-surgical-rehabilitation',
  'stroke-rehabilitation',
  'posture-correction-program',
  'geriatric-mobility-therapy',
];
